<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19099_159851)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.3646 0.613521C12.515 0.46216 12.7389 0.46216 12.8893 0.613521C13.0398 0.764042 13.0398 0.98742 12.8893 1.13788L11.9131 2.1141C12.2276 2.32409 12.5129 2.58104 12.7608 2.87494C13.3546 3.57859 13.7334 4.49457 13.7853 5.48695C13.7856 5.49148 13.786 5.49599 13.7863 5.50049C13.7867 5.50626 13.7872 5.51202 13.7874 5.51782C13.7905 5.58539 13.7921 5.65332 13.7921 5.7215H4.77164C4.77164 5.65332 4.77314 5.58539 4.77633 5.51782C4.77657 5.51265 4.77694 5.50752 4.77732 5.50238C4.77769 5.49725 4.77807 5.49211 4.77831 5.48695C4.83039 4.49457 5.20909 3.57865 5.80282 2.87488C6.05083 2.58098 6.33601 2.32403 6.65051 2.11404L5.67447 1.13782C5.52395 0.98742 5.52395 0.764042 5.67447 0.613521C5.82487 0.46216 6.04867 0.46216 6.19919 0.613521L7.20814 1.61918L7.25481 1.66566C7.85305 1.36606 8.52385 1.21645 9.27081 1.215L9.28186 1.21488H9.28198L9.29291 1.215C10.0399 1.21645 10.7107 1.36606 11.309 1.66566L11.3556 1.61918L12.3646 0.613521ZM6.83797 3.84437C6.83797 4.15562 7.0903 4.40795 7.40155 4.40795C7.7128 4.40795 7.96513 4.15562 7.96513 3.84437C7.96513 3.53312 7.7128 3.28079 7.40155 3.28079C7.0903 3.28079 6.83797 3.53312 6.83797 3.84437ZM10.5986 3.84437C10.5986 4.15562 10.851 4.40795 11.1622 4.40795C11.4735 4.40795 11.7258 4.15562 11.7258 3.84437C11.7258 3.53312 11.4735 3.28079 11.1622 3.28079C10.851 3.28079 10.5986 3.53312 10.5986 3.84437ZM2.89255 13.9897C3.49446 13.9897 4.01924 13.4649 4.01924 12.863V7.60052C4.01924 7.00186 3.49452 6.47432 2.89255 6.47432C2.29071 6.47432 1.76599 7.00186 1.76599 7.60052V12.863C1.76599 13.4649 2.29071 13.9897 2.89255 13.9897ZM12.2875 17.3733C12.2875 17.9751 11.7627 18.4999 11.1608 18.4999C10.559 18.4999 10.0342 17.9751 10.0342 17.3733V14.742H8.52956V17.3733C8.52956 17.9752 8.00478 18.5 7.40299 18.5C6.80103 18.5 6.27631 17.9752 6.27631 17.3733V14.742H5.52395C5.07256 14.742 4.77164 14.4411 4.77164 13.9897V6.47432H13.7921V13.9897C13.7921 14.441 13.4913 14.742 13.0398 14.742H12.2875V17.3733ZM16.7977 12.863C16.7977 13.4649 16.273 13.9897 15.6711 13.9897C15.0692 13.9897 14.5445 13.4649 14.5445 12.863V7.60052C14.5445 7.00186 15.0692 6.47432 15.6711 6.47432C16.273 6.47432 16.7977 7.00186 16.7977 7.60052V12.863Z"
        fill="none"
        class="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_19099_159851">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.28186 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AndroidIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
